// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as $$String from "rescript/lib/es6/string.js";
import Cp_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/cp_icon.png";
import Fc_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fc_icon.png";
import Fw_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fw_icon.png";
import Mc_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/mc_icon.png";
import Sd_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/sd_icon.png";
import Sj_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/sj_icon.png";
import Ss_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/ss_icon.png";
import St_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/st_icon.png";
import Sw_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/sw_icon.png";
import Wb_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wb_icon.png";
import Wf_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wf_icon.png";
import Ws_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/ws_icon.png";
import Fcu_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fcu_icon.png";
import Fwm_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fwm_icon.png";
import Jig_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/jig_icon.png";
import Mem_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/mem_icon.png";
import Smc_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/smc_icon.png";
import Stw_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/stw_icon.png";
import Wam_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wam_icon.png";
import Wbc_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wbc_icon.png";
import Wbd_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wbd_icon.png";
import Wbw_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/wbw_icon.png";
import Snap_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/snap_icon.png";
import Video_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/video_icon.png";
import Fwacroc_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fwacroc_icon.png";
import Fwapenguin_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/fwapenguin_icon.png";
import Placeholder_iconPng from "@literacyplanet/client_assets/src/primary_activity_icons/placeholder_icon.png";
import Spell_test_primaryPng from "@literacyplanet/client_assets/src/primary_activity_icons/spell_test_primary.png";

function MyWordsIcons$DeleteIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 448 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z",
                  fill: "currentColor"
                }));
}

var DeleteIcon = {
  make: MyWordsIcons$DeleteIcon
};

function MyWordsIcons$PlayIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 576 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z",
                  fill: "currentColor"
                }));
}

var PlayIcon = {
  make: MyWordsIcons$PlayIcon
};

function MyWordsIcons$WordListPlayIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 69 72",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M47.8,33.73a2.36,2.36,0,0,1,1.2,1.4,2.77,2.77,0,0,1,0,1.8,2.36,2.36,0,0,1-1.2,1.4l-20.4,12a2.52,2.52,0,0,1-1.9.3,3.15,3.15,0,0,1-1.7-.9,4,4,0,0,1-1.1-2V24.33a3.33,3.33,0,0,1,1.1-2.1,2.59,2.59,0,0,1,1.7-.9,2.32,2.32,0,0,1,1.8.4Z",
                  fill: "currentColor"
                }));
}

var WordListPlayIcon = {
  make: MyWordsIcons$WordListPlayIcon
};

function MyWordsIcons$SearchIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
                  fill: "currentColor"
                }));
}

var SearchIcon = {
  make: MyWordsIcons$SearchIcon
};

function MyWordsIcons$PlusIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M0,0h24v24H0V0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M12,24C5.3,24,0,18.7,0,12S5.3,0,12,0s12,5.3,12,12S18.7,24,12,24z M13.7,5.1h-3.4v5.1H5.1v3.4h5.1v5.1h3.4\n	v-5.1h5.1v-3.4h-5.1V5.1z",
                  fill: "currentColor"
                }));
}

var PlusIcon = {
  make: MyWordsIcons$PlusIcon
};

function MyWordsIcons$RightIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M0 0h24v24H0V0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
                  fill: "currentColor",
                  transform: "matrix(-1,0,0,-1,24,24)"
                }));
}

var RightIcon = {
  make: MyWordsIcons$RightIcon
};

function MyWordsIcons$LeftIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M0 0h24v24H0V0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
                  fill: "currentColor"
                }));
}

var LeftIcon = {
  make: MyWordsIcons$LeftIcon
};

function MyWordsIcons$MyWordsIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 1000 1000",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M523.4,159.32a24.89,24.89,0,0,0-22.5,14.24l42-4.77A24.86,24.86,0,0,0,523.4,159.32Z"
                }), React.createElement("path", {
                  d: "M731.39,148c-9.18,1.77-61,7.22-134.85,15.52-10.64-28.58-45.16-48.95-77.45-48.95-36.06,0-72.16,30.14-79.47,65.27-99.72,11.39-184.33,21.92-198.14,23.9-31.53,4.51-67.91,53.69-67.91,84.46V839.07c0,58.84,60.63,58.67,84.88,58.67S697.26,848,731.39,843.63c78.54-10,91.88-64.73,91.88-111V212.54C823.27,159.32,768.45,140.9,731.39,148ZM500.9,173.56a24.89,24.89,0,0,1,42-4.77Z"
                }), React.createElement("path", {
                  d: "M723.13,827.59c-32.51,4.16-427.32,51.53-450.42,51.53s-80.84,6-80.84-55.88V298.63c0-29.31,34.65-76.15,64.67-80.44s441.18-51.06,466.59-53.09,80.84,0,80.84,51V721.92C804,765.93,797.93,818,723.13,827.59Z",
                  fill: "#aa734d"
                }), React.createElement("path", {
                  d: "M697,792c-28.63,3.71-376.47,45.33-396.82,45.39-46.47.14-71.23,5.34-71.23-49.22V326c0-46,14.13-64.8,57-70.87,26.46-3.75,388.62-46.77,411.07-46.77,39.82,0,71.23-9.39,71.23,44.91V698.93C768.25,762.19,775.86,781.81,697,792Z",
                  fill: "#ffecc7"
                }), React.createElement("path", {
                  d: "M700.79,794.43c-27.13,3.51-356.64,42.94-375.92,43-44,.14-67.47,5.06-67.47-46.63V353c0-43.56,13.38-61.39,54-67.14,25.06-3.55,368.13-44.3,389.41-44.3,37.72,0,67.47-8.9,67.47,42.54V706.24C768.26,766.17,775.47,784.75,700.79,794.43Z",
                  fill: "#f3c50d"
                }), React.createElement("path", {
                  d: "M662.34,725.69c-22,2.85-289.06,34.8-304.68,34.85-35.68.11-54.69,4.1-54.69-37.79V367.88c0-35.31,10.85-49.76,43.75-54.42,20.32-2.88,298.38-35.91,315.62-35.91,30.57,0,54.68-7.21,54.68,34.49V654.21C717,702.78,722.87,717.85,662.34,725.69Z",
                  fill: "#e0bb1e"
                }), React.createElement("path", {
                  d: "M644.9,701.78c-19.3,2.5-253.73,30.55-267.44,30.59-31.32.1-48,3.6-48-33.17V387.7c0-31,9.52-43.67,38.4-47.76,17.83-2.53,253.9-31.52,269-31.52,26.84,0,48-6.33,48,30.26V639C684.9,681.67,698,694.89,644.9,701.78Z",
                  fill: "#dfe8ef"
                }), React.createElement("path", {
                  d: "M367.86,732.37c13.71,0,257.74-28.09,277-30.59,53.13-6.89,40-20.11,40-62.75V338.68c0-36.59-21.16-30.26-48-30.26-15.14,0-257.77,30.15-275.61,32.68Z",
                  fill: "#dad9f4"
                }), React.createElement("rect", {
                  height: "28.07",
                  width: "173.22",
                  fill: "#a3a3aa",
                  rx: "14.03",
                  transform: "translate(-36.69 56.33) rotate(-5.41)",
                  x: "490.99",
                  y: "402.3"
                }), React.createElement("rect", {
                  height: "28.07",
                  width: "173.22",
                  fill: "#a3a3aa",
                  rx: "14.03",
                  transform: "translate(-47.26 56.64) rotate(-5.41)",
                  x: "488.99",
                  y: "514.24"
                }), React.createElement("rect", {
                  height: "28.07",
                  width: "173.22",
                  fill: "#a3a3aa",
                  rx: "14.03",
                  transform: "translate(-57.45 56.84) rotate(-5.41)",
                  x: "485.99",
                  y: "622.17"
                }), React.createElement("polygon", {
                  fill: "#75d83a",
                  points: "378.01 435.75 395.64 415.55 411.24 430.37 456.57 382.62 475.85 401.41 414.21 466.27 378.01 435.75"
                }), React.createElement("polygon", {
                  fill: "#75d83a",
                  points: "378.01 550.67 395.64 530.46 411.24 545.28 456.57 497.53 475.85 516.32 414.21 581.18 378.01 550.67"
                }), React.createElement("polygon", {
                  fill: "#75d83a",
                  points: "378.01 661.32 395.64 641.11 411.24 655.93 456.57 608.18 475.85 626.97 414.21 691.83 378.01 661.32"
                }), React.createElement("path", {
                  d: "M590.5,187.88a71.62,71.62,0,0,0-69.56-54.61c-37.15,0-67.69,33.58-71.25,70.43l-85,9.55v132l302.63-32v-134Zm-65.45,35.41a23.72,23.72,0,1,1,23.71-23.71A23.72,23.72,0,0,1,525.05,223.29Z",
                  fill: "#f1a204"
                }), React.createElement("path", {
                  d: "M449.69,283.7l-85,9.55v52l302.63-32v-54l-76.82,8.63Z",
                  fill: "#d68a03"
                }));
}

var MyWordsIcon = {
  make: MyWordsIcons$MyWordsIcon
};

function MyWordsIcons$SpinnerIcon(props) {
  return React.createElement("svg", {
              className: props.className + " SpinnerIcon",
              viewBox: "0 0 80 80",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  id: "spinner",
                  d: "M40,72C22.4,72,8,57.6,8,40C8,22.4,\n      22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2\n      s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,\n      28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z",
                  fill: "currentColor"
                }, React.createElement("animateTransform", {
                      type: "rotate",
                      attributeName: "transform",
                      attributeType: "xml",
                      dur: "1s",
                      from: "0 40 40",
                      repeatCount: "indefinite",
                      to_: "360 40 40"
                    })));
}

var SpinnerIcon = {
  make: MyWordsIcons$SpinnerIcon
};

function MyWordsIcons$TrophyIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              fill: "currentColor",
              viewBox: "0 0 512 512",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("g", undefined, React.createElement("path", {
                      d: "M486.4,25.6h-76.8V0H102.4v25.6H25.6C10.24,25.6,0,35.84,0,51.2v61.44c0,58.88,43.52,107.52,102.4,115.2v2.56\n			c0,74.24,51.2,135.68,120.32,151.04L204.8,435.2h-58.88c-10.24,0-20.48,7.68-23.04,17.92L102.4,512h307.2l-20.48-58.88\n			c-2.56-10.24-12.8-17.92-23.04-17.92H307.2l-17.92-53.76c69.12-15.36,120.32-76.8,120.32-151.04v-2.56\n			c58.88-7.68,102.4-56.32,102.4-115.2V51.2C512,35.84,501.76,25.6,486.4,25.6z M102.4,176.64c-28.16-7.68-51.2-33.28-51.2-64V76.8\n			h51.2V176.64z M307.2,256L256,227.84L204.8,256l12.8-51.2l-38.4-51.2h53.76L256,102.4l23.04,51.2h53.76l-38.4,51.2L307.2,256z\n			 M460.8,112.64c0,30.72-23.04,58.88-51.2,64V76.8h51.2V112.64z"
                    })));
}

var TrophyIcon = {
  make: MyWordsIcons$TrophyIcon
};

function MyWordsIcons$ProgressImageIcon(props) {
  var progressState = props.progressState;
  var __imageUrl = props.imageUrl;
  var imageUrl = __imageUrl !== undefined ? __imageUrl : "";
  return React.createElement("svg", {
              className: props.className,
              fill: "none",
              viewBox: "0 0 196 196",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("circle", {
                  cx: "98",
                  cy: "98",
                  fill: "white",
                  r: "98"
                }), React.createElement("mask", {
                  id: "mask0",
                  height: "196",
                  width: "98",
                  maskUnits: "userSpaceOnUse",
                  x: "98",
                  y: "0"
                }, React.createElement("rect", {
                      height: "196",
                      width: "98",
                      fill: "white",
                      x: "98"
                    })), progressState === "Started" ? React.createElement("g", {
                    mask: "url(#mask0)"
                  }, React.createElement("circle", {
                        cx: "98",
                        cy: "98",
                        fill: "#5BFF40",
                        r: "98"
                      })) : (
                progressState === "Finished" ? React.createElement("circle", {
                        cx: "98",
                        cy: "98",
                        fill: "#5BFF40",
                        r: "98"
                      }) : null
              ), React.createElement("mask", {
                  id: "mask1",
                  height: "176",
                  width: "176",
                  maskUnits: "userSpaceOnUse",
                  x: "10",
                  y: "10"
                }, React.createElement("circle", {
                      cx: "98",
                      cy: "98",
                      fill: "white",
                      r: "88"
                    })), React.createElement("g", {
                  mask: "url(#mask1)"
                }, React.createElement("image", {
                      id: "image0",
                      height: "196",
                      href: imageUrl,
                      width: "196"
                    })), React.createElement("defs", undefined, React.createElement("pattern", {
                      id: "pattern0",
                      height: "1",
                      width: "1",
                      patternContentUnits: "objectBoundingBox"
                    }, React.createElement("use", {
                          href: "#image0"
                        }))));
}

var ProgressImageIcon = {
  make: MyWordsIcons$ProgressImageIcon
};

function iconOfKind(kind) {
  var match = $$String.lowercase_ascii(kind);
  switch (match) {
    case "cp" :
        return Cp_iconPng;
    case "fc" :
        return Fc_iconPng;
    case "fcu" :
        return Fcu_iconPng;
    case "fw" :
        return Fw_iconPng;
    case "fwacroc" :
        return Fwacroc_iconPng;
    case "fwapenguin" :
        return Fwapenguin_iconPng;
    case "fwm" :
        return Fwm_iconPng;
    case "instructional" :
        return Video_iconPng;
    case "jig" :
        return Jig_iconPng;
    case "mc" :
        return Mc_iconPng;
    case "mem" :
        return Mem_iconPng;
    case "sj" :
        return Sj_iconPng;
    case "smc" :
        return Smc_iconPng;
    case "snap" :
        return Snap_iconPng;
    case "spell_test" :
        return Spell_test_primaryPng;
    case "ss" :
        return Ss_iconPng;
    case "st" :
        return St_iconPng;
    case "stw" :
        return Stw_iconPng;
    case "sw" :
        return Sw_iconPng;
    case "lesson" :
    case "sd" :
    case "tupperware" :
        return Sd_iconPng;
    case "wam" :
        return Wam_iconPng;
    case "wb" :
        return Wb_iconPng;
    case "wbcard" :
        return Wbc_iconPng;
    case "wbdesert" :
        return Wbd_iconPng;
    case "wbwaterfall" :
        return Wbw_iconPng;
    case "wf" :
        return Wf_iconPng;
    case "ws" :
        return Ws_iconPng;
    default:
      return Placeholder_iconPng;
  }
}

function MyWordsIcons$EditIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 528.899 528.899",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981\n		c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611\n		C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069\n		L27.473,390.597L0.3,512.69z",
                  fill: "currentColor"
                }));
}

var EditIcon = {
  make: MyWordsIcons$EditIcon
};

function MyWordsIcons$NavDeleteIcon(props) {
  return React.createElement("svg", {
              className: props.className,
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M0 0h24v24H0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M0 0h24v24H0V0z",
                  fill: "none"
                }), React.createElement("path", {
                  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z",
                  fill: "currentColor"
                }));
}

var NavDeleteIcon = {
  make: MyWordsIcons$NavDeleteIcon
};

export {
  DeleteIcon ,
  PlayIcon ,
  WordListPlayIcon ,
  SearchIcon ,
  PlusIcon ,
  RightIcon ,
  LeftIcon ,
  MyWordsIcon ,
  SpinnerIcon ,
  TrophyIcon ,
  ProgressImageIcon ,
  iconOfKind ,
  EditIcon ,
  NavDeleteIcon ,
}
/* react Not a pure module */
